export const SIDEBAR = 'SIDEBAR';
export const COLLAPSE_SIDEBAR = `${SIDEBAR}/COLLAPSE`;
